import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import BootstrapVue from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VueLocalStorage from 'vue-localstorage'
import VueLodash from 'vue-lodash'
import vueHeadful from 'vue-headful'
import * as VueGoogleMaps from 'vue2-google-maps'
import DatePicker from 'vue2-datepicker'
import VModal from 'vue-js-modal'
import VueMask from 'v-mask'
import 'vue2-datepicker/index.css'
import VueMeta from 'vue-meta'

import './registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(VueLocalStorage)
Vue.use(VueLodash, '_')
Vue.use(VueGoogleMaps)
Vue.use(VModal, { adaptive: true, reset: true })
Vue.use(VueMask)
Vue.use(VueMeta)

Vue.component('vue-headful', vueHeadful)
Vue.component('date-picker', DatePicker)

Vue.config.productionTip = true
// const baseURL = 'http://localhost:8880'
// if (typeof baseURL !== 'undefined') {
//   // Vue.axios.defaults.baseURL = 'https://rentacar.epicbit.pt/'
//   Vue.axios.defaults.baseURL = baseURL
// }
Vue.axios.defaults.withCredentials = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
